<template>
  <BaseListPage
      :name="name"
      :base-query="baseQuery"
      :store-path="storePath"
      :response-path="responsePath"
      :save-key="saveKey"
      :table-set-list="tableSetList"
      :table-data-list="sortedList"
      title="受注数一覧"
      title-class="ecStock-header"
      icon="stock"
      :detail-data="detailData">
    <span slot="headerAction"
        class="action_button">
      <el-dropdown
          v-show="showActionList">
        <el-button size="small">
          アクション
          <i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu
            slot="dropdown"
            class="header-action-menu">
          <ToDownload
              ref="download"
              page-key="orderQuantity_list"
              :conditions="conditions"
              :keyword="searchKeyword"
              :is-and-search="isAndSearch" />
        </el-dropdown-menu>
      </el-dropdown>
    </span>
  </BaseListPage>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import _ from 'lodash'
import * as define from '@/define'
import * as query from '@/queries/product'
import x from '@/components/mixins/mixin'

import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseListPage from '@/components/organisms/BaseListPage'
import ToDownload from '@/components/organisms/ToDownload'

export default {
  name: 'OrderQuantityList',
  components: {
    BaseListPage,
    ToDownload
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      localIsParentLoaded: false,
      showActionList: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.OrderQuantity.listIndex,
      tableSetList: (state) => state.OrderQuantity.tableSetList,
      searchKeyword: (state) => state.OrderQuantity.searchKeyword || '',
      isAndSearch: (state) => state.OrderQuantity.isAndSearch || false,
      conditions: (state) => state.OrderQuantity.searchConditions || {},
      sites: (state) => state.sites
    }),
    ...mapGetters({
      getSortedList: 'sortedList',
      getServiceSiteConfig: 'getServiceSiteConfig'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'orderQuantityList'
    },
    storePath () {
      return 'OrderQuantity'
    },
    saveKey () {
      return 'orderQuantityCondition'
    },
    responsePath () {
      return 'data.orderQuantities.edges'
    },
    returnPath () {
      return '/orderQuantity'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_ORDER_QUANTITY_LIST
    },
    detailData () {
      return { id: 1 }
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      return [
        { type: 'String', label: '品番', path: 'node.sku.code', sortable: 'custom', width: 250 },
        { type: 'String', label: '商品名', path: 'node.sku.name', width: 300 },
        { type: 'String', label: 'JAN', path: 'node.sku.jan', width: 250 },
        { type: 'Date', label: '発売日', path: 'node.sku.releaseDatetime', sortable: 'custom', dateFormat: 'YYYY/MM/DD', width: 150 },
        { type: 'Date', label: '一次予約締日', dateFormat: 'YYYY/MM/DD', path: (row) => {
          if (row.node.attributes.length === 0) {
            return ''
          } else {
            let find = row.node.attributes.findIndex(function (item) {
              return item.attrId === 'firstReservationDeadline'
            })
            if (find > -1) {
              return row.node.attributes[find].attrValue
            } else {
              return 0
            }
          }
        }, elementType: ELEMENT_TYPE.FUNCTION, width: 150 },
        { type: 'String', sortable: true, label: '受付可能', path: (row) => {
          if (row.node.ecStock.length === 0) {
            return 0
          } else {
            let find = row.node.ecStock.findIndex(function (item) {
              return item.stockType === 2
            })
            if (find > -1) {
              return Number(row.node.ecStock[find].qty)
            } else {
              return 0
            }
          }
        }, elementType: ELEMENT_TYPE.FUNCTION, width: 150, sortBy: (row) => {
          if (row.node.ecStock.length === 0) {
            return 0
          } else {
            let find = row.node.ecStock.findIndex(function (item) {
              return item.stockType === 2
            })
            if (find > -1) {
              return Number(row.node.ecStock[find].qty)
            } else {
              return 0
            }
          }
        } },
        { type: 'String', label: '在庫', path: (row) => {
          if (row.node.ecStockDistr.length === 0) {
            return 0
          } else {
            let find = row.node.ecStockDistr.findIndex(function (item) {
              return item.stockType === 1
            })
            if (find > -1) {
              return Number(row.node.ecStockDistr[find].amount)
            } else {
              return 0
            }
          }
        }, elementType: ELEMENT_TYPE.FUNCTION, width: 150 },
        { type: 'String', label: '注残', path: (row) => {
          let count = 0
          if (row.node.ecStock.length > 0) {
            for (const itemEcStock of row.node.ecStock) {
              count += Number(itemEcStock.exported) + Number(itemEcStock.ordered)
            }
          }
          return count
        }, elementType: ELEMENT_TYPE.FUNCTION, width: 150 },
        { type: 'String', label: '引当', path: (row) => {
          let count = 0
          if (row.node.ecStock.length > 0) {
            for (const itemEcStock of row.node.ecStock) {
              if (itemEcStock.stockType === 1) {
                count += Number(itemEcStock.exported) + Number(itemEcStock.ordered)
              }
            }
          }
          return count
        }, elementType: ELEMENT_TYPE.FUNCTION, width: 100 },
        { type: 'String', label: '発注', path: (row) => {
          return row.node.sendOrder == null
            ? 0
            : Number(row.node.sendOrder.unallocatedQty)
        }, elementType: ELEMENT_TYPE.FUNCTION, width: 100, sortable: true, sortBy: (row) => {
          return row.node.sendOrder == null
            ? 0
            : Number(row.node.sendOrder.unallocatedQty)
        } },
        { type: 'String', label: '引当可能', path: (row) => {
          let stock = 0
          if (row.node.ecStockDistr.length > 0) {
            for (const itemEcStockDistr of row.node.ecStockDistr) {
              if (itemEcStockDistr.stockType === 1) {
                stock += Number(itemEcStockDistr.amount)
              }
            }
          }
          let allocated = 0
          if (row.node.ecStock.length > 0) {
            for (const itemEcStock of row.node.ecStock) {
              if (itemEcStock.stockType === 1) {
                allocated += Number(itemEcStock.exported) + Number(itemEcStock.ordered)
              }
            }
          }
          return stock - allocated
        }, elementType: ELEMENT_TYPE.FUNCTION, width: 100 },
        { type: 'String', label: '処理待ち', path: (row) => {
          return row.node.orderItem == null
            ? 0
            : Number(row.node.orderItem.pendingQty)
        }, elementType: ELEMENT_TYPE.FUNCTION, width: 100 },
        { type: 'String', label: '注文累計', path: (row) => {
          return row.node.orderItem == null
            ? 0
            : Number(row.node.orderItem.orderedQty)
        }, elementType: ELEMENT_TYPE.FUNCTION, width: 100 }
      ]
    }
  },
  created () {

    // ダウンロードが可能のとき、アクションを表示
    const tempThisComponent = this
    setTimeout(() => {
      tempThisComponent.showActionList = this.$isFunctionShown(_.get(tempThisComponent.$refs, 'download.toDownload.funcId', ''))
    }, 1)

    this.$store.dispatch({
      type: 'set',
      states: {
        'OrderQuantity/tableSetList': this._tableSetList
      }
    })
  },
  methods: {
  }
}
</script>
